import api from "../_app/api";
import { CommunicationDetail } from "./types";
import { SORT_REQUEST_PARAMETER_NAME, SortRequestParam } from "../_app/components/Table/helpers";
import { convertResponseToPage, isOldResponseFormat } from "../_app/utils/page";
import { Query } from "../filter/types";

export const getCommunications = async (
  accountId: string,
  page: number,
  limit: number,
  sort?: SortRequestParam,
  queries: Query[] = [],
) => {
  const params = new URLSearchParams();

  if (sort) {
    params.append(SORT_REQUEST_PARAMETER_NAME, `${sort.column},${sort.direction}`);
  }
  params.append("page", page.toString());
  params.append("size", limit.toString());
  queries.forEach((query) => {
    params.append(query.id, query.value);
  });
  params.append("account-id", accountId);

  const { data }: { data: any } = await api({
    method: "GET",
    url: "/communications",
    params,
  });

  if (isOldResponseFormat<CommunicationDetail>(data)) {
    return convertResponseToPage<CommunicationDetail>(data, sort !== null);
  }

  return data;
};

export const getDocumentPresignedUrl = async (accountId: string, communicationId: string) => {
  const { data }: { data: string } = await api({
    method: "GET",
    url: `/communications/${communicationId}/file`,
    params: { "account-id": accountId },
  });
  return data;
};

export const getExportCsv = async (accountId: string) => {
  return api({
    method: "GET",
    url: "/communications/export",
    responseType: "arraybuffer",
    params: { "account-id": accountId },
  });
};
